const Profile_Petzzshop = ({ item }) => {
  return <img src={item?.placeholderImage} className={` w-full `} />;
};

export default Profile_Petzzshop;
